module.exports = __webpack_public_path__ + "img/logoOrientestProBlanc.95d9ff01.svg";